import {
  SelectedDynamicFilterModel,
  PriceRange,
  getCatalogFiltersFacets,
  transformDynamicFilterOptions,
} from '@marketplace-web/catalog/catalog-data'
import {
  useCatalogContext,
  DynamicFilterReducerAction,
} from '@marketplace-web/catalog/catalog-page-data'

type FetchDynamicFiltersFacetsParams = {
  selectedDynamicFilters: Array<SelectedDynamicFilterModel>
  selectedTemporaryCatalogIds?: Array<number>
  selectedTemporaryPriceRange?: PriceRange
  filterCode: string
  isLazy?: boolean
}

const useFetchDynamicFiltersFacets = () => {
  const { state, dispatch, refs } = useCatalogContext()

  const fetchDynamicFilterFacets = async ({
    selectedDynamicFilters,
    selectedTemporaryCatalogIds,
    selectedTemporaryPriceRange,
    filterCode,
    isLazy,
  }: FetchDynamicFiltersFacetsParams) => {
    const { filters } = state
    refs.pendingFacetsType.current = filterCode

    dispatch({
      type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_REQUEST,
      payload: undefined,
    })

    const currentCatalogIds = selectedTemporaryCatalogIds ?? filters.catalogIds
    const currentPriceRange = selectedTemporaryPriceRange ?? {
      priceFrom: filters.priceFrom,
      priceTo: filters.priceTo,
    }

    const response = await getCatalogFiltersFacets({
      ...filters,
      selectedDynamicFilters,
      catalogIds: currentCatalogIds,
      priceFrom: currentPriceRange.priceFrom,
      priceTo: currentPriceRange.priceTo,
      filterCode,
    })

    if (!refs.isFiltersFetching.current) {
      refs.pendingFacetsType.current = null
    }

    if ('errors' in response) {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_FAILURE,
        payload: { errors: response.errors },
      })
    } else {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_SUCCESS,
        payload: {
          totalCount: response.total_count,
          totalCountMax: response.total_count_max,
          code: response.filter_code ?? null,
          options: transformDynamicFilterOptions(response.options),
        },
      })

      if (isLazy) {
        dispatch({
          type: DynamicFilterReducerAction.SET_DYNAMIC_FILTER_OPTIONS,
          payload: {
            code: response.filter_code || null,
            newOptions: transformDynamicFilterOptions(response.options),
          },
        })
      }
    }
  }

  return fetchDynamicFilterFacets
}

export default useFetchDynamicFiltersFacets
